import { Link } from 'react-router-dom';
import { deepDiveSection } from '@/mocks/homeData';

export default function DeepDiveSection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-6 lg:gap-16 mb-10 md:mb-14">
          <div className="lg:w-1/3">
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-none tracking-tight">
              {deepDiveSection.title}
              <br />
              {deepDiveSection.titleLine2}
            </h2>
          </div>
          <div className="lg:w-2/3 lg:pt-3">
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl">
              {deepDiveSection.description}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          <Link
            to={deepDiveSection.featured.link}
            className="group bg-foreground-900 rounded-2xl p-5 md:p-6 flex flex-col cursor-pointer"
          >
            <h3 className="text-background-50 text-lg md:text-xl font-bold mb-3 leading-snug">
              {deepDiveSection.featured.title}
            </h3>
            <p className="text-background-50/60 text-sm leading-relaxed mb-5 flex-1">
              {deepDiveSection.featured.summary}
            </p>
            <div className="w-full aspect-[16/10] rounded-xl overflow-hidden">
              <img
                src={deepDiveSection.featured.image}
                alt={deepDiveSection.featured.title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                title={deepDiveSection.featured.title}
              />
            </div>
          </Link>

          {deepDiveSection.articles.map((article) => (
            <Link
              key={article.id}
              to={article.link}
              className="group bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col cursor-pointer border border-background-200/60"
            >
              <div className="flex items-center gap-2 mb-4">
                <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full">
                  <i className="ri-fire-line text-xs"></i>
                  {article.tag}
                </span>
              </div>
              <div className="w-full aspect-[16/10] rounded-xl overflow-hidden mb-4">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  title={article.title}
                />
              </div>
              <h3 className="text-foreground-950 text-base md:text-lg font-bold leading-snug mb-1.5">
                {article.title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm mb-4">
                {article.subtitle}
              </p>
              <div className="mt-auto">
                <span className="inline-flex items-center gap-1.5 bg-primary-500 text-background-50 text-xs font-semibold px-4 py-2 rounded-full group-hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  查看详情
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}